<template>

  <div>

    <v-card v-if="$store.state.MyNewMessage == 0" class="mx-auto mb-3" @click="GoToMessage">

      <v-card-title class="pa-2 d-flex flex-column align-center justify-center text-center">


        <span>Нет новых сообщений</span>

      </v-card-title>

      <!-- <v-card-actions>
        <v-btn block>
          Написать
        </v-btn>
      </v-card-actions> -->

    </v-card>

    <v-card v-if="$store.state.MyNewMessage > 0" class="mx-auto mb-3" @click="GoToMessage">

      <v-card-title class="pa-2 d-flex flex-column align-center justify-center text-center">

        <!-- <v-icon>
        mdi-email-alert-outline
      </v-icon> -->
        📩 У вас {{ $store.state.MyNewMessage }} новых сообщений
      </v-card-title>

      <!-- <v-card-subtitle class="pa-2">

          У вас есть новые сообщения {{ $store.state.MyNewMessage }}


    </v-card-subtitle> -->

      <v-card-actions>
        <v-btn block>
          Показать
        </v-btn>
      </v-card-actions>
    </v-card>

  </div>

</template>

<script>


export default {

  // data () {
  //   return {
  //     MewMessage: 0,
  //   }
  // },

  methods: {

    getNewMessage() {

      let json = {
        'pathUrl': this.$store.state.urlPathAuth,  /// путь
        'method': 'get',
        'alert': true,
        'url': 'newmessage',
        'loading': false,
        //'update': 'UpdateGetLog',
        'postData': {}
      }
      this.$store.dispatch('axiosData', json)
        .then(response => {
          this.$store.state.MyNewMessage = response.data
        })
    },

    GoToMessage() {

      this.$router.push('/message')
    }

  },

  mounted() {

    this.getNewMessage()
  }
}



</script>